import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { sourceCodeEnum } from '../enums';
export var escape2Html = function escape2Html(str) {
  //转义字符转换普通字符的方法
  var arrEntities = {
    'lt': '<',
    'gt': '>',
    'nbsp': ' ',
    'amp': '&',
    'quot': '"'
  };
  return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) {
    return arrEntities[t];
  });
};
export var tagNameMap = {
  dingding: ['dt-open-data', 'open-id', 'open-type'],
  weixin: ['ww-open-data', 'openid', 'type'],
  abookcrypto: ['xx-open-data', 'openid', 'type']
};
export function getRegExp(type) {
  return new RegExp('^\\$' + type + '=([^$]+)\\$$');
}
export var regExpMap = {
  userName: getRegExp('userName'),
  departmentName: getRegExp('departmentName'),
  userTitle: getRegExp('userTitle'),
  itemName: getRegExp('(userName|departmentName|userTitle)'),
  allItem: new RegExp('\\$(userName|departmentName|userTitle)=([^$]+)\\$', 'g')
};
/**
 * 获取所有的 要素 功能点
 * @returns
 */

var getAllFunctions = function getAllFunctions() {
  try {
    return JSON.parse(window.sessionStorage.getItem('yxt_factors')) || {};
  } catch (e) {
    console.error(e);
    return {};
  }
};
/**
 * 检查对应的功能点的状态(处理已过期的状态)
 * @param {*} point
 * 2.要素上架-已购买未过期（启用）-显示
 */


var checkTimeOutFnc = function checkTimeOutFnc(point) {
  var localFactors = getAllFunctions();
  return localFactors[point] && localFactors[point].webState;
};
/**
 * 是通讯录加密环境，且未过期
 * @returns 
 */


export var isAbookCrypto = function isAbookCrypto() {
  var webState = checkTimeOutFnc('tongxunlu_jiami');
  return webState === 2;
};
export function ignoreElement(tagNames, Vue) {
  if (typeof tagNames === 'string') {
    tagNames = [tagNames];
  }

  var _Vue$config$ignoredEl = Vue.config.ignoredElements,
      ignoredElements = _Vue$config$ignoredEl === void 0 ? [] : _Vue$config$ignoredEl;
  tagNames.forEach(function (tagName) {
    if (ignoredElements.includes(tagName) === false) {
      ignoredElements.push(tagName);
    }
  });
  Vue.config.ignoredElements = ignoredElements;
}
export var openPlatform = function openPlatform() {
  var code = localStorage.sourceCode;

  if (sourceCodeEnum.weixin === code) {
    return 'weixin';
  } else if (sourceCodeEnum.dingding === code) {
    return 'dingding';
  } else if (isAbookCrypto()) {
    return 'abookcrypto';
  }

  return;
};
export var isOpenPlatform = function isOpenPlatform() {
  return !!openPlatform();
};
export function checkOpenType(type) {
  var isDingding = localStorage.sourceCode === sourceCodeEnum.dingding;
  var validTypes = ['userName', 'departmentName'];

  if (isDingding) {
    validTypes.push('userTitle');
  }

  if (isOpenPlatform()) {
    var hasType = validTypes.includes(type);

    if (!hasType) {
      console.warn('no support type;type=', type);
    }

    return hasType;
  }

  return false;
}
export var renderItemTag = function renderItemTag(h, openid, type) {
  if (localStorage.sourceCode === sourceCodeEnum.dingding) {
    return (// @ts-ignore
      h("yxtbiz-dd-open-data", {
        attrs: {
          type: type === 'departmentName' ? 'deptName' : type,
          openid: openid
        }
      })
    );
  } else if (localStorage.sourceCode === sourceCodeEnum.weixin) {
    return (// @ts-ignore
      h("yxtbiz-ww-open-data", {
        attrs: {
          type: type,
          openid: openid
        }
      })
    );
  } else if (isAbookCrypto()) {
    return (// @ts-ignore
      h("yxtbiz-open-data", {
        attrs: {
          type: type,
          openid: openid
        }
      })
    );
  } else {
    // @ts-ignore
    return h("span", {
      "class": "yxt-open-value"
    }, ["none"]);
  }
};
export var getOpenDataMatchHtml = function getOpenDataMatchHtml(text) {
  return text.replace(regExpMap.allItem, function (matchVal, p1, p2, offset) {
    var tagP = tagNameMap[openPlatform()];
    if (!tagP) return;
    var tagName = tagP[0];
    var idName = tagP[1];
    var typeName = tagP[2];
    return "<" + tagName + " " + typeName + "=\"" + p1 + "\" " + idName + "=\"" + p2 + "\" ></" + tagName + ">";
  });
};
export var getOpenDataMatch = function getOpenDataMatch(h, text, tagName) {
  var nodes = [];
  var offsetStart = 0;
  text.replace(regExpMap.allItem, function (matchVal, p1, p2, offset) {
    var openid = p2;
    var type = p1;

    if (offset > 0) {
      nodes.push(text.substring(offsetStart, offset));
      offsetStart = offset;
    }

    offsetStart += matchVal.length;

    if (openid && checkOpenType(type)) {
      nodes.push(renderItemTag(h, openid, type));
    }

    return matchVal;
  });

  if (offsetStart < text.length) {
    nodes.push(text.substr(offsetStart));
  }

  return h(tagName || "span", {
    "class": "yxt-open-data-match"
  }, nodes);
};
/**
 * 用于处理微信开放数据的名称
 * @param  {createElement} h 必传，使当前方法支持JSX语法
 * @param  {string} name 原名称数据
 * @param  {string} type userName： 匹配的是用户名，departmentName：匹配的是部门名
 * @return {JSX} rander 对象
 */

export var getOpenDataJSX = function getOpenDataJSX(h, name, type, split) {
  if (!name || checkOpenType(type) === false) {
    // @ts-ignore
    return h("span", {
      "class": "yxt-open-value"
    }, [name]);
  } // 解析出用于呈现的源数据


  var tags = name.split(split).map(function (val) {
    var matched = val.match(regExpMap[type]);
    var openid = matched && matched[1];

    if (!openid) {
      return val;
    }

    return renderItemTag(h, openid, type);
  }); // 单元素不包含外层节点

  if (tags.length === 1 && typeof tags[0] !== 'string') return tags[0]; // 多元素包含外层节点

  var children = [];
  tags.forEach(function (data, index) {
    if (index) children.push(split);
    children.push(data);
  }); // @ts-ignore

  return h("span", {
    "class": "yxt-open-data-wrap"
  }, [children]);
};
/**
 * 用于处理微信开放数据的名称，去除模板
 * @param  {string} name 原名称字符串，内容可混合带有模板的数据
 * @return {string} 返回企业微信中的名称，去除多余模板
 */

export var getOpenData = function getOpenData(name) {
  if (!name) return '';
  var re = /\$(?:(?:userName)|(?:departmentName))=([^$]+)\$/g;
  return name.replace(re, function (m, value) {
    return value;
  });
};
export var decorateAttachShadow = function decorateAttachShadow() {
  var _Element$prototype$at = Element.prototype.attachShadow,
      attachShadow = _Element$prototype$at === void 0 ? '' : _Element$prototype$at;
  var isChanged = attachShadow.toString().indexOf('native code') === -1; // @ts-ignore

  if (isChanged) return attachShadow.isMine; // @ts-ignore

  Element.prototype._oriAttachShadow = attachShadow || function () {
    console.log('no attachShadow');
  };

  var myAttachShadow = function myAttachShadow(option) {
    if (option === void 0) {
      option = {};
    }

    return this._oriAttachShadow(_extends({}, option, {
      mode: 'open'
    }));
  };

  myAttachShadow.isMine = true;
  Element.prototype.attachShadow = myAttachShadow; // @ts-ignore

  return Element.prototype.attachShadow.isMine; // attachShadow writable maybe false
};
export var getOpenValue = function getOpenValue(openId, isDingding) {
  var _tagNameMap = tagNameMap[isDingding ? 'dingding' : openPlatform()],
      tagName = _tagNameMap[0],
      attrName = _tagNameMap[1];
  var selector = tagName + "[" + attrName + "=\"" + openId + "\"]";
  var ele = document.querySelector(selector);

  if (!ele) {
    console.warn("not found " + selector);
    return;
  }

  return ele.shadowRoot ? ele.shadowRoot.textContent : '';
};
/**
 * 游戏在企业微信环境下特殊提供的方法
 * @param openId 
 * @returns 
 */

export var getGameQywxOpenValue = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(openId) {
    var _tagNameMap$openPlatf, tagName, attrName, selector, ele, result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _tagNameMap$openPlatf = tagNameMap[openPlatform()], tagName = _tagNameMap$openPlatf[0], attrName = _tagNameMap$openPlatf[1];
            selector = tagName + "[" + attrName + "=\"" + openId + "\"]";
            ele = document.querySelector(selector);

            if (ele) {
              _context.next = 6;
              break;
            }

            console.warn("not found " + selector);
            return _context.abrupt("return");

          case 6:
            _context.next = 8;
            return initCanvas(ele.getAttribute('type'), openId);

          case 8:
            result = _context.sent;
            return _context.abrupt("return", result);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getGameQywxOpenValue(_x) {
    return _ref.apply(this, arguments);
  };
}();

var initCanvas = function initCanvas(type, openId) {
  var WWOpenData = window.WWOpenData;
  if (WWOpenData.initCanvas) WWOpenData.initCanvas();
  var items = [{
    type: type,
    id: openId
  }];
  console.warn("params: { type: " + type + ", openId: " + openId + " }");
  return new Promise(function (resolve, reject) {
    WWOpenData.prefetch({
      items: items
    }, function (err, data) {
      if (err) {
        console.warn("WWOpenData.prefetch.error: " + err);
        return reject(err);
      }

      console.warn("WWOpenData.prefetch.success: " + data);
      return resolve(data);
    });
  });
};